/**
 * TopShelf: material-style ripple on product/resource cards.
 *
 * Reuses the `@keyframes ripple-animation` already shipped by
 * menu-drawer-kith.css, which is loaded globally via the kith header section.
 *
 * Implementation notes:
 *   - Attaches a single delegated `click` listener to document.
 *   - Injects a non-interactive ripple host once per card so we never have to
 *     mutate the Horizon `.resource-card` element's own position/overflow
 *     inline styles; CSS below handles positioning.
 *   - Skips clicks that land on interactive children (quick-add button,
 *     variant swatches, form controls) so those widgets keep their own
 *     feedback.
 */
(function initTopshelfRipple() {
  if (window.__topshelfRippleBound) return;
  window.__topshelfRippleBound = true;

  const CARD_SELECTOR = '.resource-card';
  const SKIP_SELECTOR = [
    'button',
    '[role="button"]',
    'input',
    'select',
    'textarea',
    'label',
    'variant-swatches',
    'quick-add',
    '.quick-add',
    '.variant-picker',
    '.product-card-actions',
    '.product-card__add-to-cart',
    '.product-form__buttons',
    'a:not(.resource-card__link)',
  ].join(',');

  function getRippleHost(card) {
    let host = card.querySelector(':scope > .topshelf-ripple-host');
    if (host) return host;
    host = document.createElement('span');
    host.className = 'topshelf-ripple-host';
    host.setAttribute('aria-hidden', 'true');
    card.appendChild(host);
    return host;
  }

  function spawnRipple(e, card) {
    const host = getRippleHost(card);
    host.querySelectorAll('.ripple').forEach((el) => el.remove());

    const rect = card.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 0.9;
    const clientX = typeof e.clientX === 'number' ? e.clientX : rect.left + rect.width / 2;
    const clientY = typeof e.clientY === 'number' ? e.clientY : rect.top + rect.height / 2;
    const x = clientX - rect.left - size / 2;
    const y = clientY - rect.top - size / 2;

    const ripple = document.createElement('span');
    ripple.className = 'ripple';
    ripple.style.cssText = [
      `width:${size}px`,
      `height:${size}px`,
      `left:${x}px`,
      `top:${y}px`,
      'position:absolute',
      'border-radius:50%',
      'background:rgba(0,0,0,0.18)',
      'pointer-events:none',
      'transform:scale(0)',
      'transform-origin:center',
      'animation:ripple-animation 0.6s linear',
      'z-index:9999',
    ].join(';');

    host.appendChild(ripple);
    setTimeout(() => ripple.remove(), 700);
  }

  document.addEventListener(
    'click',
    (e) => {
      const card = e.target.closest(CARD_SELECTOR);
      if (!card) return;
      if (e.target.closest(SKIP_SELECTOR)) return;
      spawnRipple(e, card);
    },
    { passive: true }
  );
})();
